import React from 'react';

// Título de pantalla. La navegación y el cierre de sesión viven en el menú
// lateral (escritorio) y la barra inferior (móvil): components/layout.
// En móvil el título ya aparece en la barra superior, así que aquí solo se
// muestra el subtítulo en una línea para no repetir encabezados.
export default function DashboardHeader({ activeTab = 'dashboard', title, subtitle, actions }) {
    return (
        <div className="mb-4 md:mb-6 flex flex-col lg:flex-row lg:items-end justify-between gap-3 md:gap-4 pb-3 md:pb-5 border-b border-white/10">
            <div className="min-w-0">
                <h1 className="hidden md:block text-2xl lg:text-3xl font-bold tracking-tight text-white">
                    {title || (activeTab === 'analytics' ? 'Estadísticas Completas' : 'Dashboard de Ventas')}
                </h1>
                <p className="text-white/50 text-xs md:text-base truncate lg:whitespace-normal">
                    {subtitle || (activeTab === 'analytics' ? 'Seguimiento de metas de venta y rendimiento.' : 'Resumen general de operaciones y métricas de DynamiaERP')}
                </p>
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
    );
}
